import type { FeatureManifest } from '@/platform/navigation/featureManifest'

export const sparkCurriculumManifest: FeatureManifest = {
  id: 'curriculum-spark',
  path: 'curriculums/spark/*',
  navPath: '/curriculums/spark',
  label: 'Spark',
  description: 'Chương trình tiếng Anh cấp độ Spark',
  navigationGroup: { id: 'curriculums', label: 'Chương trình' },
  load: () => import('./entry'),
}
